module.exports = __webpack_public_path__ + "resources/img/logo_partner_web_7.c7c8c7d6cde2b19a04196dfd885a5f6e.png";